/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Electricity = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M14.1744 1.27435C14.6782 0.667485 15.6571 1.14975 15.4829 1.91903L13.7084 8.75342H19.7514C20.3514 8.75342 20.6947 9.41376 20.3892 9.89887L20.3285 9.98249L9.32849 22.2325C8.8247 22.8393 7.84586 22.3571 8.01993 21.5879L9.79243 14.7534H3.75143C3.1515 14.7534 2.80813 14.0931 3.11364 13.608L3.17437 13.5244L14.1744 1.27435ZM13.3284 4.64242L5.34843 13.2534H10.7314C11.1781 13.2534 11.5175 13.6383 11.4787 14.0689L11.4629 14.1689L10.1734 18.8644L18.1524 10.2534H12.7704C12.3238 10.2534 11.9843 9.86847 12.0231 9.43784L12.0389 9.33781L13.3284 4.64242Z"
                        fill={color}
                    />
                </svg>
        );
    };
